import on from "../dom/on"
import toggle_class from "../dom/toggle_class"
import register_dom_update from "../navigation/register_dom_update"

let scrolled = false

const addscroll = () => {
  const scroll =
    document.body.style.position === "fixed"
      ? parseInt(document.body.style.top, 10) * -1
      : window.scrollY

  const next = scrolled ? scroll > 50 : scroll > 130

  if (next === scrolled) return
  scrolled = next
  toggle_class(document.body, { "scrolled-body": scrolled })
}

on("scroll", null, addscroll)

register_dom_update({
  after: addscroll,
})
